export function sanitizeText(text: string): string {
  return text
    .split('\n')
    .map((t) => t.trim().replace(/\t/g, '  '))
    .join('\n')
    .trim();
}
